import './style.css';
import SelectDefault, { SingleValue } from 'react-select';
import styles from './styles.module.scss';
import SelectOptions from 'models/Profile/SelectOptions';

type Select = {
  placeholder: string
  options : Array<SelectOptions>;
  classNamePrefix: string,
  onChange : (value : SingleValue<SelectOptions>) => void
}

function Select(props : Select) : JSX.Element {
  const selectStyle = {
    // eslint-disable-next-line
    menu: (provided : any) => ({
      ...provided,
      borderRadius: '8px',
      boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.2)',
      margin: 0
    }),

    // eslint-disable-next-line
    option: (provided : any, state : any) : any => ({
      ...provided,

      color: state.isFocused ? '#0E718A' : '#353535',
      fontFamily: 'Lato',
      fontWeight: state.isFocused ? 'bold' : '400',
      textTransform: 'capitalize',
      padding: 16,
      margin: 0
    }),

    // eslint-disable-next-line
    control: (provided : any) => ({
      ...provided,
      boxShadow: 'none',
      border: '1px solid #CCCCCC',
      borderRadius: '4px',
      fontStyle: 'italic',

      '&:hover': {
        border: '1px solid #CCCCCC',
      },
    }),

    // eslint-disable-next-line
    dropdownIndicator: (base : any) => ({
      ...base,
      color: '#1995A6'
    })
  };

  return (
    <SelectDefault
      styles={selectStyle}
      className={styles['biobar-select']}
      classNamePrefix={props.classNamePrefix}
      onChange={props.onChange}
      options={props.options}
      placeholder={props.placeholder}
      // eslint-disable-next-line
      theme={(theme) : any => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          primary25: '#EDFCFD',
          primary: '#EDFCFD',
        },
      })}
    />
  );
}

export default Select;